import { render } from "./whatsapp.vue?vue&type=template&id=19e45fba&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"

import "./whatsapp.vue?vue&type=style&index=0&id=19e45fba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e45fba"]])

export default __exports__